// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavService } from '@services/nav.service';
import { AuthService } from '../../services/auth.service';
import { AppEventEx } from '@interfaces/interfaces';
import { AuthenticationStatus } from '@interfaces/auth.interfaces';

@Component({
    selector: 'enter-verification',
    templateUrl: './enter-verification.component.html',
    styleUrls: ['./enter-verification.component.scss'],
})
export class EnterVerificationComponent implements OnInit, OnDestroy {
    @Input() phone: string = null;
    @Output() verify$ = new EventEmitter<AppEventEx<AuthenticationStatus>>();
    isComponentAlive = true;
    isLoading = false;
    verifyCodeForm: FormGroup;
    error: string = null;
    disableSubmit: boolean = false;

    constructor(
        private readonly authService: AuthService,
        private readonly navService: NavService
    ) {
        this.verifyCodeForm = new FormGroup({
            token: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
            password2: new FormControl('', [Validators.required]),
        });
    }

    ngOnInit(): void {
        this.navService.setTitle('Authentication');
        this.phone = this.phone ? `***-***-${this.phone.substring(this.phone.length - 4, this.phone.length)}` : 'N/A';
    }

    get invalidVerificationCode(): boolean {
        return this.verifyCodeForm.get('token').invalid && this.verifyCodeForm.get('token').errors && this.verifyCodeForm.get('token').touched;
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    verificationCodeSubmit(group: FormGroup): void {
        this.isLoading = true;
        this.disableSubmit = true;
        this.authService.sendMFA(
            this.verifyCodeForm.value.token,
            (result) => {
                this.isLoading = false;
                this.verify$.emit({
                    context: 'success',
                    data: result,
                });
            },
            () => {
                this.isLoading = false;
                this.disableSubmit = false;
                this.verify$.emit({
                    context: 'failure',
                    data: null,
                });
            }
        );
    }

    // used for stellantis redirect link
    redirect() {
        this.verify$.emit({
            context: 'redirect',
            data: null,
        });
    }

    requestNewToken() {
        this.verify$.emit({
            context: 'newToken',
            data: null,
        });
    }
}
